"use strict";

exports.__esModule = true;
exports.default = void 0;

var _createPath = _interopRequireDefault(require("./utils/createPath"));

var _ensureLocation = _interopRequireDefault(require("./utils/ensureLocation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function noop() {}

var ServerProtocol =
/*#__PURE__*/
function () {
  function ServerProtocol(url) {
    this._location = (0, _ensureLocation.default)(url);
  }

  var _proto = ServerProtocol.prototype;

  _proto.init = function init() {
    return _extends({
      action: 'POP'
    }, this._location);
  };

  _proto.subscribe = function subscribe() {
    // Server protocol emits no events.
    return noop;
  };

  _proto.createHref = function createHref(location) {
    return (0, _createPath.default)(location);
  } // The other methods are not implemented, because ServerProtocol instances
  // cannot navigate.
  ;

  return ServerProtocol;
}();

exports.default = ServerProtocol;
module.exports = exports.default;